import styled from 'styled-components'
import { palette } from '@theme'


export default styled.div<{ invert?: boolean }>`
  margin-top: 1em;
  color: ${props => props.invert ? palette.white : palette.thunder};
`
